/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Maintenance Monitor API
 * API for supporting Maintenance Monitor application
 * OpenAPI spec version: 1.0.0-Draft
 */
import * as axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  FindLeadsParams,
  Lead,
  LeadId,
  LeadNote,
  LeadPatch,
  NewLeadNote,
  WorkflowPatch
} from '../../models';




  export const getLeads = (axiosInstance: AxiosInstance = axios.default) => {
/**
 * Query for leads
 */
const findLeads = (
    params?: FindLeadsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Lead[]>> => {
    return axiosInstance.get(
      `/leads`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * Update workflow for a lead
 */
const patchWorkflow = (
    leadId: LeadId,
    workflowPatch: WorkflowPatch, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.patch(
      `/leads/${leadId}/workflow`,
      workflowPatch,options
    );
  }
/**
 * patches a lead
 */
const patchLead = (
    leadId: LeadId,
    leadPatch: LeadPatch, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.patch(
      `/leads/${leadId}`,
      leadPatch,options
    );
  }
/**
 * Get all notes for a lead, including history
 */
const findNotes = (
    leadId: LeadId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LeadNote[]>> => {
    return axiosInstance.get(
      `/leads/${leadId}/notes`,options
    );
  }
/**
 * Create a new note for a lead
 */
const createNote = (
    leadId: LeadId,
    newLeadNote: NewLeadNote, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/leads/${leadId}/notes`,
      newLeadNote,options
    );
  }
return {findLeads,patchWorkflow,patchLead,findNotes,createNote}};
export type FindLeadsResult = AxiosResponse<Lead[]>
export type PatchWorkflowResult = AxiosResponse<void>
export type PatchLeadResult = AxiosResponse<void>
export type FindNotesResult = AxiosResponse<LeadNote[]>
export type CreateNoteResult = AxiosResponse<void>
